{
  "comment": "M9 CH-2a seeded First Rush hulks (src/hulks/place.ts, D-570 H-1/H-9): each system gets perSystem[region] [min, max] hulk points drawn from the galaxy seed by hash (never a shared RNG), finite (a claimed or scrapped hulk never comes back). None in the gate region; the rim has the most. placementTables (M10 P3b1, spec §6.11): versioned placement tables, keys 1..N contiguous; each table's eligibleHulls are the small/medium hulls a hulk can be (strategic hulls.json ids) with a draw weight per region, so few high-value hulls (miner, salvager, hauler) sit near the core. Table 1 is frozen (a snapshot test holds it; it is M9's placement): a change to placement is a new table, never an edit, so a live survey card's unclaimed hulk never moves. A galaxy places from its own table (P3b2: the career's hulkTable, absent = 1); claimability, kits and hull names read the union of all tables (src/hulks/data.ts), so a table-1 hulk stays claimable after a later table. Table 2 (M10 P4b3, spec §4.6 and §6.11, D-TBD P4b-10) is frozen too once shipped (new careers write hulkTable: 2; roll forward only, never removed): table 1 with the Varro hulls at Rush points (interceptor and gunship) swapped for the relic escort, which takes their place in the walk and their summed weights, plus the relic skiff and the relic salvage tug at the end, rim heavy [P]. The relic names (text.hulls) describe what the player sees, never a model history (spec §4.6). Each hulk sits offsetM [min, max] metres outside a seeded body's mass-lock shell (much closer in than the M7 story sites, so the scan ping finds them), at least clearanceM from every station, relay, lane ring, POI (so never on a derelict), story site and other hulk, and outside every body's shell; tries candidates per hulk, and a hulk with no clear candidate is dropped. excludeSystems: 'home', 'columnNine' and 'okaforLab' (the M7 story sites' systems) never hold hulks. Placeholders for the balance pass; tune freely. CH-4 (survey and flaws, src/hulks/{flaws,survey}.ts, D-570 H-5, MS-2; read-only for later M9 cards): survey.minScannerTier: a hulk survey (the wreck scan on a hulk) needs Scanner Mk II or better. flaws: the named flaws (bit i of the flaws bitmask = flaws[i], at most 12; append only, never reorder: saved bitmasks name them by index), each scaling one ships.json stat by mult (worse: < 1, or > 1 for mass), the hull value by valueMult (a hull with several flaws multiplies them; CH-8 insures and pays out at hull value × that), weight in the draw, and fix: per good, the share of the hull value (Σ buildCost × base price) a yard charges to remove it, paid in whole units of that good (CH-10; every share ≥ 0.36 so fixing 3 flaws costs more than a new hull). flawCountWeights: draw weights for 1, 2, 3 flaws (a hulk always has at least one). frEdges: a seeded First Rush hulk (hk: key) carries exactly one small non-tetherstone stat edge (D7(c)), drawn by hash, stored in bits 12..15 of the bitmask; mult ≤ maxMult. kit: share of each claim-cost ware (rounded up per ware) plus fuelCells per hull, goods only (no credits, no tetherstone); the claim cost is the component-tier part of buildCost (plating, electronics, drive and weapon parts; the kit rule T52, in code: src/hulks/flaws.ts claimCostOf), so a refined or import ware in a build cost never enters a kit or comes out of a scrap, while yard fixes and the insurance cap keep the full hull value. hazards: per region, the share of hulks with a coolant hazard and with squatters, and the squat fence fee in credits (CH-6 reuses M7 vent/fence/fight). scrap: value = share × (1 − perFlaw × flaws) × claim value (the claim cost at base price, T52), or the claim-cost wares at the same factor (CH-11); share lowered from the drafted 0.35 to 0.25 so the H-5 data test (one-flaw scrap ≤ 0.9 × the kit at base price) passes for every hull. combat.strengthMultPerFlaw: CH-9b, a flawed fleet ship fights off-screen at this per flaw. insurance.putInShare (CH-8b, D-572): a claimed ship insures at most this share of what the player put in (the kit plus each yard fix, goods at base price), and never above hull value × the flaws' valueMult; the worker pays insured − the flat rebuild fee, so a loss never returns more than putInShare × what went in (the insurance no-printer test in insure.test.ts). claim.answerTimeoutS (R3-2): a claim order the fleet link has not answered in this many seconds says so on comms (text.live.claimSlow); the order stays queued and its answer still comes. All placeholders for the balance pass.",
  "enabled": true,
  "perSystem": {
    "gate": [0, 0],
    "mid": [0, 1],
    "deep": [0, 2],
    "rim": [1, 3]
  },
  "placementTables": {
    "1": {
      "eligibleHulls": {
        "light_fighter": {
          "gate": 0,
          "mid": 4,
          "deep": 3,
          "rim": 2
        },
        "interceptor": {
          "gate": 0,
          "mid": 4,
          "deep": 3,
          "rim": 2
        },
        "gunship": {
          "gate": 0,
          "mid": 2,
          "deep": 3,
          "rim": 3
        },
        "miner": {
          "gate": 0,
          "mid": 1,
          "deep": 2,
          "rim": 3
        },
        "salvager": {
          "gate": 0,
          "mid": 0.5,
          "deep": 1.5,
          "rim": 2.5
        },
        "hauler": {
          "gate": 0,
          "mid": 0.5,
          "deep": 1.5,
          "rim": 2.5
        }
      }
    },
    "2": {
      "eligibleHulls": {
        "light_fighter": {
          "gate": 0,
          "mid": 4,
          "deep": 3,
          "rim": 2
        },
        "relic_escort": {
          "gate": 0,
          "mid": 6,
          "deep": 6,
          "rim": 5
        },
        "miner": {
          "gate": 0,
          "mid": 1,
          "deep": 2,
          "rim": 3
        },
        "salvager": {
          "gate": 0,
          "mid": 0.5,
          "deep": 1.5,
          "rim": 2.5
        },
        "hauler": {
          "gate": 0,
          "mid": 0.5,
          "deep": 1.5,
          "rim": 2.5
        },
        "relic_skiff": {
          "gate": 0,
          "mid": 0.5,
          "deep": 1,
          "rim": 2.5
        },
        "relic_salvage_tug": {
          "gate": 0,
          "mid": 0,
          "deep": 0.5,
          "rim": 2
        }
      }
    }
  },
  "offsetM": [50000, 500000],
  "clearanceM": 50000,
  "tries": 48,
  "excludeSystems": ["home", "columnNine", "okaforLab"],
  "survey": {
    "minScannerTier": 2
  },
  "flaws": [
    {
      "id": "buckled_frame",
      "name": "Buckled spaceframe",
      "stat": "hull",
      "mult": 0.8,
      "valueMult": 0.86,
      "weight": 1,
      "fix": {
        "hull_plating": 0.4
      }
    },
    {
      "id": "weak_emitters",
      "name": "Weak shield emitters",
      "stat": "shield",
      "mult": 0.75,
      "valueMult": 0.88,
      "weight": 1,
      "fix": {
        "electronics": 0.38
      }
    },
    {
      "id": "slow_capacitors",
      "name": "Slow shield capacitors",
      "stat": "shieldRegen",
      "mult": 0.7,
      "valueMult": 0.9,
      "weight": 1,
      "fix": {
        "electronics": 0.36
      }
    },
    {
      "id": "misaligned_drive",
      "name": "Misaligned main drive",
      "stat": "thrustForward",
      "mult": 0.85,
      "valueMult": 0.86,
      "weight": 1,
      "fix": {
        "drive_parts": 0.4
      }
    },
    {
      "id": "seized_retros",
      "name": "Seized retro thrusters",
      "stat": "thrustReverse",
      "mult": 0.8,
      "valueMult": 0.9,
      "weight": 1,
      "fix": {
        "drive_parts": 0.36
      }
    },
    {
      "id": "sticky_jets",
      "name": "Sticky manoeuvring jets",
      "stat": "thrustLateral",
      "mult": 0.8,
      "valueMult": 0.9,
      "weight": 1,
      "fix": {
        "drive_parts": 0.36
      }
    },
    {
      "id": "tripped_governor",
      "name": "Tripped drive governor",
      "stat": "maxSpeed",
      "mult": 0.9,
      "valueMult": 0.88,
      "weight": 1,
      "fix": {
        "drive_parts": 0.2,
        "electronics": 0.18
      }
    },
    {
      "id": "leaky_capacitors",
      "name": "Leaky capacitor bank",
      "stat": "energy",
      "mult": 0.8,
      "valueMult": 0.9,
      "weight": 1,
      "fix": {
        "electronics": 0.36
      }
    },
    {
      "id": "tired_reactor",
      "name": "Tired reactor",
      "stat": "energyRegen",
      "mult": 0.8,
      "valueMult": 0.88,
      "weight": 1,
      "fix": {
        "electronics": 0.38
      }
    },
    {
      "id": "fused_ballast",
      "name": "Fused ballast frames",
      "stat": "mass",
      "mult": 1.1,
      "valueMult": 0.92,
      "weight": 1,
      "fix": {
        "hull_plating": 0.36
      }
    }
  ],
  "flawCountWeights": [5, 3, 2],
  "frEdges": {
    "maxMult": 1.1,
    "edges": [
      {
        "id": "rush_reactor",
        "name": "Rush-pattern reactor",
        "stat": "energyRegen",
        "mult": 1.06
      },
      {
        "id": "rush_emitters",
        "name": "Rush-pattern shield emitters",
        "stat": "shieldRegen",
        "mult": 1.06
      },
      {
        "id": "rush_jets",
        "name": "Rush-pattern thruster quads",
        "stat": "thrustLateral",
        "mult": 1.05
      },
      {
        "id": "rush_frame",
        "name": "Rush-pattern frame",
        "stat": "hull",
        "mult": 1.05
      }
    ]
  },
  "kit": {
    "share": 0.25,
    "fuelCells": {
      "light_fighter": 4,
      "interceptor": 4,
      "gunship": 6,
      "miner": 8,
      "salvager": 8,
      "hauler": 10,
      "relic_escort": 4,
      "relic_skiff": 4,
      "relic_salvage_tug": 8
    }
  },
  "hazards": {
    "coolantShare": {
      "gate": 0,
      "mid": 0.3,
      "deep": 0.45,
      "rim": 0.6
    },
    "squatterShare": {
      "gate": 0,
      "mid": 0.15,
      "deep": 0.3,
      "rim": 0.45
    },
    "fenceFee": {
      "gate": 0,
      "mid": 1500,
      "deep": 2500,
      "rim": 4000
    }
  },
  "scrap": {
    "share": 0.25,
    "perFlaw": 0.15
  },
  "combat": {
    "strengthMultPerFlaw": 0.95
  },
  "insurance": {
    "putInShare": 0.9
  },
  "claim": {
    "answerTimeoutS": 10
  },
  "text": {
    "title": "Hulk survey: {hull}",
    "scanTitle": "DISABLED HULL · CLAIMABLE",
    "close": "Close",
    "hulls": {
      "light_fighter": "Light fighter (Kestrel line)",
      "interceptor": "Interceptor",
      "gunship": "Gunship",
      "miner": "Mining ship",
      "salvager": "Salvager",
      "hauler": "Hauler",
      "relic_escort": "Charter-pattern escort, maker's mark worn off",
      "relic_skiff": "Charter-pattern skiff, maker's mark worn off",
      "relic_salvage_tug": "Charter-pattern salvage tug, maker's mark worn off"
    },
    "stats": {
      "hull": "hull",
      "shield": "shields",
      "shieldRegen": "shield regen",
      "thrustForward": "main thrust",
      "thrustReverse": "reverse thrust",
      "thrustLateral": "lateral thrust",
      "thrustVertical": "vertical thrust",
      "maxSpeed": "top speed",
      "energy": "capacitor",
      "energyRegen": "reactor output",
      "mass": "mass"
    },
    "flawsHeader": "Flaws:",
    "flawsNone": "Flaws: none",
    "flawRow": "  {name} ({stat} {change}%)",
    "edge": "First Rush edge: {name} ({stat} {change}%)",
    "value": "Claimed value: {pct}% of a new hull",
    "coolant": "Hazard: coolant leak (vent it before work)",
    "coolantVented": "Hazard: coolant vented",
    "squatters": "Squatters aboard (fight them off, or pay {fee} cr)",
    "squatCleared": "Squatters cleared",
    "kitHeader": "Kit to make it flightworthy (delivered / needed):",
    "goodRow": "  {label}: {delivered} / {need} (hold {inHold})",
    "refusals": {
      "scanner": "A hulk survey needs Scanner Mk II or better.",
      "notEligible": "Nothing here worth claiming.",
      "noSite": "Survey the hulk first (a wreck scan with Scanner Mk II or better)."
    },
    "prompts": {
      "vent": "Vent the hulk's coolant",
      "fence": "Pay the squatters off",
      "fight": "Call out the squatters",
      "start": "Start the kit on this hulk",
      "deliver": "Deliver to the hulk's kit",
      "claim": "Claim the hulk"
    },
    "claims": {
      "header": "Open hulk claims",
      "row": "{hull}: kit {delivered} / {needed} delivered",
      "abandon": "Abandon claim"
    },
    "hangar": {
      "scrapInWingGroup": "It flies in a wing group: end the escort order first."
    },
    "live": {
      "found": "Hulk found: {hull}. Fly in and scan it.",
      "kitStarted": "Claim opened: deliver the kit to make it flightworthy.",
      "kitAbandoned": "Claim abandoned: the goods delivered to its kit are lost.",
      "abandonRefused": "The abandon did not go through ({reason}); the claim stays open.",
      "claimLost": "Claim closed: the {hull} is gone, and the goods in its kit with it.",
      "delivered": "Delivered {what}.",
      "kitComplete": "The kit is complete: claim the hulk.",
      "claimed": "Claimed: the {hull} is yours. It flies itself to {station} and registers when it docks.",
      "claimedHome": "Claimed: the {hull} is yours. Your last dock can't take it, so it flies itself home to {station} and registers when it docks.",
      "stationIn": "your last dock in {system}",
      "squatOut": "The squatters come out shooting. Fight them off, or pay {fee} cr at the hulk.",
      "squatLeft": "You broke off the fight; the squatters still hold the hulk.",
      "busy": "A fight is already on here.",
      "speed": "Slow down at the hulk.",
      "tooManyOpen": "You hold {max} open claims already; finish or abandon one.",
      "nothing": "Nothing the kit still needs is in the hold (parts must be Serviceable or better).",
      "claimRefused": "The claim did not go through ({reason}); the kit stays complete. Try again.",
      "noFleet": "The fleet link is down; try again in a moment.",
      "claimPending": "The last claim order is still going through; try again in a moment.",
      "claimSlow": "The fleet link has not answered the claim order yet; it stays queued, and the answer comes here."
    }
  }
}
